module.exports = function() {
  return new Worker("/cvat-static/" + "unzip_imgs.worker.285621cb058e70d40ef4.js");
};